import { InputGroup, InputRightElement, InputProps } from "@chakra-ui/react";
import React, { forwardRef } from "react";
import Input from "./Input";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
	({ name, ...props }, ref) => {
		const [show, setShow] = React.useState(false);
		const handleClick = () => setShow(!show);

		return (
			<InputGroup size="md">
				<Input
					{...props}
					name={name ?? "password"}
					ref={ref}
					type={show ? "text" : "password"}
				/>
				<InputRightElement color="gray.500">
					{show && <ViewOffIcon h="1.75rem" onClick={handleClick} />}
					{!show && <ViewIcon h="1.75rem" onClick={handleClick} />}
				</InputRightElement>
			</InputGroup>
		);
	},
);

export default PasswordInput;
